import React, { Component } from "react";
import "../App.css";
import Twitter from "../images/twitt.png";
import Facebook from "../images/fb.png";
import Instagram from "../images/insta.png";

class Footer extends Component {
  render() {
    return (
      <footer className="FooterContainer">
        <div className="copyright">
          <h3>copyright BookSpace 2021</h3>
        </div>
        <div className="SiteMap">
          <a className="footerTag" href="">
            contact us
          </a>
          <a className="footerTag" href="">
            about
          </a>
          <a className="footerTag" href="">
            sitemap
          </a>
        </div>
        <div className="SocialApps">
          <h3>Find us at</h3>
          <img src={Twitter} className="social-img" alt="twitter"></img>
          <img src={Facebook} className="social-img" alt="facebook"></img>
          <img src={Instagram} className="social-img" alt="instagram"></img>
        </div>
      </footer>
    );
  }
}

export default Footer;
